import request from '@/api/request.js'

export function login(param) {
    return request({
        url: 'sys/auth/getLoginToken',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        method: 'POST',
        data: param,
    })
}

//暂时不使用
export function loginByAuthCode(param) {
    return request({
        url: 'sys/auth/loginByAuthCode',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        method: 'POST',
        data: param,
    })
}
//暂时不适用
export function getAuthCode(param) {
    return request({
        url: 'sys/auth/getAuthCode',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        method: 'POST',
        data: param,
    })
}
